import { toDateTimeString } from '@/utils';

import type { Session } from '@/types';

export const FORTY_EIGHT_HOURS_MS = 48 * 60 * 60 * 1000;
export const MEMBER_RESCHEDULE_NOTICE =
  'You can reschedule any session up to 48 hours before it starts.';
export const MEMBER_RESCHEDULE_STARTED_NOTICE =
  'This session has already started.';

export const formatSessionTime = (value?: string) =>
  value ? toDateTimeString(value).trim() : '';

const formatTimeOnly = (value?: string) => {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';

  return date.toLocaleTimeString('en', {
    hour: 'numeric',
    hour12: true,
    minute: '2-digit',
  });
};

export const formatSessionRange = (session: Session) =>
  `${formatSessionTime(session.startedAt)} - ${formatSessionTime(session.endedAt)}`;

export const formatCancellationSessionRange = (session: Session) =>
  `${formatSessionTime(session.startedAt)} - ${formatTimeOnly(session.endedAt)}`;

export const isSessionStarted = (
  startedAt: string,
  now: number = Date.now(),
) => {
  const start = new Date(startedAt).getTime();
  return Number.isFinite(start) && start <= now;
};

export const isWithinRescheduleWindow = (
  startedAt: string,
  now: number = Date.now(),
) => {
  const start = new Date(startedAt).getTime();
  return !Number.isFinite(start) || start - now <= FORTY_EIGHT_HOURS_MS;
};
